<template>
  <el-col :md="sz">

    <el-row class="rowWrapper" :style="wrapper">
      <template v-if="!responsive||(responsive&&isWindowSize('sm',true))">
        <div v-if="label" class="actionTitle">{{ label }}</div>
        <div class="rowStyle">
          <div style="flex:1;display:flex;align-items: center;justify-content: start">
            <slot name="left"></slot>
          </div>
          <div style="flex:1;display:flex;align-items: center;justify-content:center">
            <slot name="middle"></slot>
          </div>
          <div style="flex:1;display:flex;align-items: center;justify-content: end">
            <slot></slot>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="rowStyle">
          <div>
            <q-btn @click="floatMenu=!floatMenu" flat round icon="tune"></q-btn>
          </div>
          <q-space></q-space>

          <div style="flex:1;display:flex;align-items: center;justify-content:center">
            <slot name="middle"></slot>
          </div>
          <div style="flex:1;display:flex;justify-content: end">
            <slot></slot>
          </div>
          <!--          <q-space></q-space>-->

        </div>
      </template>
    </el-row>
    <!--    <q-dialog v-model="floatMenu" persistent-->
    <!--              :maximized="true"-->
    <!--              transition-show="slide-left"-->
    <!--              transition-hide="slide-right">-->
    <!--    <s-modal></s-modal>-->
    <!--    <s-modal v-model="floatMenu" position="top" size-h="30vh">-->

    <q-drawer
        v-model="floatMenu"

        :width="leftMenuWidth"

        class="action-drawer"
    >
      <div class="rowWrapper-mobile">
        <div class="rowStyle" style="padding: 1em">
          <slot name="left"></slot>
        </div>

        <!--        <div class="rowStyle">-->
        <!--          <slot name="middle"></slot>-->
        <!--        </div>-->

      </div>
    </q-drawer>
    <!--    </s-modal>-->
  </el-col>
</template>

<script>
import SModal from "./SModal.vue";

export default {
  name: "s-form-actions",
  components: {SModal},
  props: {
    responsive: {default: false},
    leftMenuWidth: {default: 100, type: Number},
    label: {type: String, default: null},
    sz: {default: 24, type: Number},
    hPadding: {type: String, default: null},
    vPadding: {type: String, default: null}
  },
  data() {
    return {

      floatMenu: false
    };
  },
  computed: {
    wrapper() {
      let stl = "";
      stl += this.vPadding
          ? "padding-top:" +
          this.vPadding +
          ";padding-bottom:" +
          this.vPadding +
          ";"
          : "";
      stl += this.hPadding
          ? "padding-left:" +
          this.hPadding +
          ";padding-right:" +
          this.hPadding +
          ";"
          : "";
      return stl;
    }
  },
  methods: {}
};
</script>
<style>
.action-rows .row div {
  padding: 2%;
}

.rowWrapper button.text {
  color: white;
  text-shadow: 0px 0px 2px;
}

.rowWrapper, .rowWrapper > div {
  padding-top: 1px;
  padding-bottom: 1px;
  background-color: #095b6940;
  justify-content: space-between;
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  margin-left: -16px;
  padding-left: 16px;
}

.rowWrapper-mobile {
  display: flex;

  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.action-drawer .q-drawer__content{
  background-color: rgba(15, 111, 128, 0.74);
}

.rowWrapper-mobile .rowStyle > div {
  flex: 1 0 100%;
  display: flex;
  margin: 2%;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}

/*
.rowWrapper button {
  padding: 1px;
}
*/
.rowStyle, .rowWrapper {
  align-items: center;
  justify-content: space-between;
  display: flex;
  flex: 1 0 100%;
  flex-wrap: wrap;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
}

.rowWrapper > div, .rowWrapper > span,.rowWrapper-mobile .rowStyle > span {
  width: 100%;
  flex: 1 0 100%;
  flex-wrap: wrap;
  display: flex;
}

.actionTitle {
  font-weight: bold;
}
</style>
